import { render, staticRenderFns } from "./recordCount.vue?vue&type=template&id=2455df7c&scoped=true&"
import script from "./recordCount.vue?vue&type=script&lang=js&"
export * from "./recordCount.vue?vue&type=script&lang=js&"
import style0 from "./recordCount.vue?vue&type=style&index=0&id=2455df7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2455df7c",
  null
  
)

export default component.exports